import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicModule } from '@ionic/angular';
import { translateConfig } from '../../config/translate.config';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AccountDeletionConfirmationPage } from './account-deletion-confirmation';
import { SharedModule } from '../../../shared';

@NgModule({
  declarations: [
    AccountDeletionConfirmationPage
  ],
  imports: [
    IonicModule,
    CommonModule,
    RouterModule.forChild([{path: '', component: AccountDeletionConfirmationPage}]),
    TranslateModule.forChild(translateConfig),
    FormsModule,
    ReactiveFormsModule,
    SharedModule
  ]
})
export class AccountDeletionConfirmationModule {}
